import { MultiversX } from "./MultiversX";
import { Polygon } from "./Polygon";
import { Ethereum } from "./Ethereum";
import { Bsc } from "./Bsc";
import * as ZoidModels from "./models/index";
import { Utilities } from "./Utilities";
import { Credentials } from "./models/instantiateClass";

export default class ZoidCore {
    public multiversX: MultiversX
    public ethereum: Ethereum
    public polygon: Polygon
    public bsc: Bsc
    public utils: Utilities
    public apiKey: string | undefined
    public authorization: string | undefined
    public env: string | undefined

    constructor({
        apiKey, 
        authorization, 
        env
    }: {
        apiKey: string | undefined, 
        authorization: string | undefined, 
        env: string | undefined
    }) {
        this.apiKey = apiKey
        this.authorization = authorization

        if (!this.apiKey && !this.authorization){
            throw new Error('ApiKey or Authorization required');
        }

        this.env = env

        const credentials: Credentials = {
            apiKey: this.apiKey,
            authorization: this.authorization,
            env:this.env
        }

        this.multiversX = new MultiversX(credentials)
        this.ethereum = new Ethereum(credentials)
        this.polygon = new Polygon(credentials)
        this.bsc = new Bsc(credentials)
        this.utils = new Utilities(credentials)
    }


        
}

export { ZoidCore, ZoidModels }